export const absoluteURL = (url) => {
    return process.env.PUBLIC_URL + url
}